import { useCallback } from "react";

import { IS_AWS_ENV } from "constants/app.constants";
import { formatRigFracCountyLabel } from "utils/map/rigFracValueMapping";

import useBetaFeatures from "hooks/useBetaFeatures";

import { useRigFracValuesQuery } from "components/project/layers/queries";

/**
 * Labels a rig/frac countyUnique "Name, ST" using /values' countyStates, so a
 * county stored bare ("Andrews") still matches the wells' "Andrews, TX".
 * Shares useRigFracTypeFilters' historical query on AWS; Azure never fetches.
 */
export function useRigFracCountyLabel(): (countyUnique: string) => string {
  const { hasFeature } = useBetaFeatures();
  const { data } = useRigFracValuesQuery({
    enabled: IS_AWS_ENV && hasFeature("Rig And Frac Layers"),
    historical: true
  });
  const countyStates = data?.countyStates;

  return useCallback(
    (countyUnique: string) =>
      formatRigFracCountyLabel(countyUnique, countyStates?.[countyUnique]),
    [countyStates]
  );
}
